import { render, staticRenderFns } from "./DivTable.vue?vue&type=template&id=cef58ba6&scoped=true&"
import script from "./DivTable.vue?vue&type=script&lang=js&"
export * from "./DivTable.vue?vue&type=script&lang=js&"
import style0 from "./DivTable.vue?vue&type=style&index=0&id=cef58ba6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cef58ba6",
  null
  
)

export default component.exports